function renderCartTemplate() {
	fetch(`${routes.cart_url}?section_id=main-cart-items`)
		.then((response) => response.text())
		.then((responseText) => {
			const html = new DOMParser().parseFromString(responseText, 'text/html');
			const cartItemsNew = $(html).find('cart-items');
			const cartItems = $('[js-cart-template] cart-items');
			cartItems.empty().append(cartItemsNew.html());
		})
		.catch(e => {
			console.error(e);
		});
}

function renderSections(data) {
	if (data.item_count === 0 ) {
		$('[js-cart-template]').addClass('is-empty');
	}else if (data.item_count > 0) {
		var cart_count = (data.item_count > 1) ? data.item_count + ' Articulos' : data.item_count + ' Articulo';
		$('[js-cart-template] [data-cart-bubble]').text(cart_count);
		$('[data-cart-count]').text(cart_count);
	}
	
	getSectionsToRender().forEach((section => {
	  	const html = new DOMParser().parseFromString(data.sections[section.section], 'text/html');
	  	const elementToReplaceNew = $(html).find(section.selector);
	  	const elementToReplace = $(section.id).find(section.selector) || $(section.id);
		elementToReplace.empty().append(elementToReplaceNew.html());
	}));
}

function enableLoading(line) {
    const cartItemElements = $('#CartItem-' + line +' [js-loading-overlay]');
    const cartItemElementsPrice = $('#CartItem-' + line +' [js-loading-price]');
    cartItemElements.removeClass('d-none');
    cartItemElementsPrice.addClass('d-none');
}

function disableLoading(line) {
    const cartItemElements = $('#CartItem-' + line +' [js-loading-overlay]');
    const cartItemElementsPrice = $('#CartItem-' + line +' [js-loading-price]');
    cartItemElements.addClass('d-none');
    cartItemElementsPrice.removeClass('d-none');
}

function updateLiveRegions(line_item, response) {
	var lineItemError = '#Line-item-error-' + line_item;
	$(lineItemError).removeClass('d-none');
	$(lineItemError).find('[data-cart-item__error-text]').empty().append(response.responseJSON.message);
}

function getSectionsToRender() {
    return [
      {
        id: '#main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '[js-contents-items]'
      },
      {
        id: '#main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '[js-contents-summary]'
      }
    ];
}
/* Update Minicart */
/* -------------------------------------------------------------------------------------- */
function updateCartTemplate(iQuantity, line_item) {
	enableLoading(line_item);

	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: {
			quantity: iQuantity,
			line: line_item,
			sections: getSectionsToRender().map((section) => section.section),
      		sections_url: window.location.pathname
		},
		dataType: 'json',           
		success: function(data) {
			renderSections(data);
		},
		complete: function() {
			disableLoading(line_item);
		},
		error: function(response) {
			updateLiveRegions(line_item, response);
		}
	});
}

document.addEventListener('DOMContentLoaded', () => {
	/* Add to cart - Minicart */
	/* -------------------------------------------------------------------------------------- */
	$('body').on('click', '.js-add-cart-from-template', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this);
		var product_id = parseFloat(el.attr("data-product-variant-id"));
		var product_quantity = parseFloat(el.attr("data-product-quantity"));
		el.find('[data-add-to-cart-text]').addClass('d-none');
		el.find('[data-loader]').removeClass('d-none');
		// Jibbitz
		var conjunto = '41433686245555';
		var parent = 'child';
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: {
				quantity: product_quantity,
				id: product_id,
				sections: getSectionsToRender().map((section) => section.section),
	      		sections_url: window.location.pathname
			},
			dataType: 'json',
			success: function(data){
				// Turn on Minicart
				renderSections(data);
				el.find('[data-add-to-cart-text]').removeClass('d-none');
				el.find('[data-loader]').addClass('d-none');
				// Product loading message on PRODUCT CARD
				el.closest('.js-item-products').find('[js-card-product-message]').removeClass('active');
				el.closest('.js-item-products').find('[text-message-warning]').empty();
				// Product loading message on QUICK VIEW
				if (el.hasClass('js-close-quickview')) {
					$('[js-quick-view-product]').removeClass('active');
					el.closest('[js-quick-view-product]').find('[js-quickview-message]').removeClass('active');
					el.closest('[js-quick-view-product]').find('[text-message-warning]').empty();
				}
			},
			error: function(response) {
				el.find('[data-add-to-cart-text]').removeClass('d-none');
				el.find('[data-loader]').addClass('d-none');
				// Product loading message on PRODUCT CARD
				el.closest('.js-item-products').find('[js-card-product-message]').addClass('active');
				el.closest('.js-item-products').find('[text-message-warning]').empty().append(response.responseJSON.description);
				// Product loading message on QUICK VIEW
				if (el.hasClass('js-close-quickview')) {
					el.closest('[js-quick-view-product]').find('[js-quickview-message]').addClass('active');
					el.closest('[js-quick-view-product]').find('[text-message-warning]').empty().append(response.responseJSON.description);
				}
			}
		});
	});
	/* Quantity Product */
	/* -------------------------------------------------------------------------------------- */
	$('[js-cart-template]').on('click', '[name=minus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-quantity-cart-template').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val()),
			line_item = parseFloat(input.attr("data-index"));
		if (oldValue <= min) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue - 1;
		}
		input.val(newVal);
		input.trigger("change");
		updateCartTemplate(newVal,line_item);
	});

	$('[js-cart-template]').on('click', '[name=plus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-quantity-cart-template').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val()),
			line_item = parseFloat(input.attr("data-index"));
		if (oldValue >= max) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue + 1;
		}
		input.val(newVal);
		input.trigger("change");
		updateCartTemplate(newVal,line_item);
	});

	$('[js-cart-template]').on('keyup', '.js-quantity-cart-template .js-quantity-input', debounce(function(){
		var input = $(this),
			inputValue = parseFloat(input.val()),
			line_item = input.attr("data-index");
		updateCartTemplate(inputValue,line_item);
	},500));
	/* Remove Product */
	/* -------------------------------------------------------------------------------------- */
	$('[js-cart-template]').on('click', 'cart-remove-button', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		var line_item = el.attr('data-index');
		updateCartTemplate(0,line_item);
	});
});